(() => {
 function init() {
  const header=document.querySelector('.header-section');
  if(!header || header.dataset.lianMeasured) return;
  header.dataset.lianMeasured='true';
  const toolbar=document.querySelector('.toolbar-section');
  // Keep promotion content in normal document flow; the original locale controls remain separate.
  const announcement=toolbar?.querySelector('.toolbar__item--announcements,.toolbar__scrolling-text');
  if(announcement){
   const flow=document.createElement('div');
   flow.className='lian-announcement-flow shopify-section';
   const inner=document.createElement('div');
   inner.className=toolbar.querySelector('.toolbar')?.className || 'toolbar';
   const width=document.createElement('div'); width.className='page-width';
   const content=document.createElement('div'); content.className='toolbar__content';
   content.append(announcement); width.append(content); inner.append(width); flow.append(inner);
   toolbar.before(flow);
  }
  const layout=header.querySelector('.header-layout');
  const nav=header.querySelector('.site-header__element--sub[data-type="nav"]');
  const icons=header.querySelector('.header-item--icons');
  const home=document.createComment('Desktop navigation home');
  if(nav) nav.before(home);
  let previousHeight=0, queued=false, lastY=Math.max(0,window.scrollY), distance=0, direction=0, keyboard=false;
  const show=()=>{header.classList.remove('lian-header-hidden');toolbar?.classList.remove('lian-header-hidden');};
  const interacting=()=> !!toolbar?.querySelector('[aria-expanded="true"]') || (keyboard && toolbar?.matches(':focus-within')) ||header.matches(':focus-within') && keyboard
    || header.matches('.search-open,.cart-open,.mobile-nav-open')
    || document.body.matches('.search-open,.cart-open,.mobile-nav-open')
    || Array.from(header.querySelectorAll('details[open],[aria-expanded="true"]:not(summary),dialog[open],.site-header__drawer.is-active')).some(el=>el.getClientRects().length && getComputedStyle(el).visibility!=='hidden')
    || !!header.querySelector('shopify-account')?.matches(':focus-within');
  const measure=()=>{
   const controls=toolbar?.querySelector('.toolbar__item--multi-selectors');
   const social=toolbar?.querySelector('.toolbar__item--social');
   const controlsWidth=(controls?.getBoundingClientRect().width || 0)+(social?.getBoundingClientRect().width || 0)+32;
   document.documentElement.style.setProperty('--lian-toolbar-controls-width',Math.ceil(controlsWidth)+'px');
   const messageHeights=Array.from(document.querySelectorAll('.lian-announcement-flow .announcement-slider__content')).map(el=>el.scrollHeight);
   const messageHeight=Math.max(0,...messageHeights);
   if(messageHeight) document.documentElement.style.setProperty('--lian-announcement-message-height',messageHeight+'px');
   const height=Math.ceil(header.getBoundingClientRect().height);
   document.documentElement.style.setProperty('--lian-toolbar-height',Math.ceil(toolbar?.getBoundingClientRect().height || 0)+'px');
   if(height && height!==previousHeight){previousHeight=height;document.documentElement.style.setProperty('--lian-sticky-header-height',height+'px');}
  };
  const layoutUpdate=()=>{
   const compact=window.innerWidth>768;
   header.classList.toggle('lian-header-compact',compact);
   if(nav && layout && icons){
    if(compact && nav.parentElement!==layout) layout.insertBefore(nav,icons);
    else if(!compact && nav.parentElement===layout) home.after(nav);
   }
   header.classList.remove('lian-menu-overflow');
   if(compact && nav && layout && icons){
    const logo=layout.querySelector('.header-item--logo');
    const menu=nav.querySelector('.site-navigation');
    const gaps=parseFloat(getComputedStyle(layout).columnGap)||0;
    const required=(logo?.getBoundingClientRect().width||0)+icons.getBoundingClientRect().width+(menu ? Array.from(menu.children).reduce((total,item)=>total+item.getBoundingClientRect().width,0) : 0)+gaps*2;
    header.classList.toggle('lian-menu-overflow',required>layout.clientWidth-4);
   }
   measure();
  };
  document.fonts?.ready.then(layoutUpdate);
  const update=()=>{
   queued=false;
   const y=Math.max(0,Math.min(window.scrollY,document.documentElement.scrollHeight-window.innerHeight));
   const delta=y-lastY; lastY=y;
   toolbar?.classList.toggle('lian-toolbar-scrolled',y>0);
   if(y<24 || interacting()){show();distance=0;return;}
   if(document.body.classList.contains('lps-nav-active')){show();distance=0;return;}
   if(Math.abs(delta)<1) return;
   const next=delta>0?1:-1;
   if(next!==direction){distance=0;direction=next;}
   distance+=Math.abs(delta);
   if(next<0 && distance>=6){show();distance=0;}
   else if(next>0 && distance>=18 && y>previousHeight+40){header.classList.add('lian-header-hidden');toolbar?.classList.add('lian-header-hidden');distance=0;}
  };
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',()=>{layoutUpdate();show();lastY=Math.max(0,window.scrollY);distance=0;},{passive:true});
  document.addEventListener('keydown',e=>{if(e.key==='Tab'){keyboard=true;show();}},{capture:true});
  document.addEventListener('pointerdown',()=>{keyboard=false;},{capture:true,passive:true});
  header.addEventListener('focusin',()=>{if(keyboard) show();});
  header.addEventListener('click',()=>{show();distance=0;});
  if(toolbar){toolbar.addEventListener('focusin',()=>{if(keyboard) show();});toolbar.addEventListener('click',()=>{show();distance=0;});new ResizeObserver(measure).observe(toolbar);}
  const flow=document.querySelector('.lian-announcement-flow');if(flow) new ResizeObserver(measure).observe(flow);
  new ResizeObserver(measure).observe(header);
  layoutUpdate();
 }
 init();
 document.addEventListener('shopify:section:load',init);
})();